import { PRODUCTS_PAGE_SIZE } from "@features/products/constants";
import {
  SeasonalProductsSection,
  SeasonalProductsSectionProps,
} from "../SeasonalProductsSection";

import { Space } from "@components/Space";
import { placeholderCurrencyProtector } from "@features/currency/utils/placeholderCurrencyProtector";
import { productsApi } from "@features/products/store";
import { useAppSelector } from "@features/store/hooks";
import { FC, memo } from "react";

interface SeasonalProductsSectionAdapterProps
  extends Omit<
    SeasonalProductsSectionProps,
    "data" | "isLoading" | "isFetching"
  > {}

const _SeasonalProductsSectionAdapter: FC<
  SeasonalProductsSectionAdapterProps
> = (props) => {
  const { ...restProps } = props;

  const selectedCurrencyInStore = useAppSelector(
    (store) => store.currency.value
  );

  const countryId = useAppSelector((store) => store.citySlice.countryId);

  const { data, isLoading, isSuccess, isFetching } =
    productsApi.useGetProductSeasonQuery({
      perPage: PRODUCTS_PAGE_SIZE,
      currency: placeholderCurrencyProtector(selectedCurrencyInStore),
      country: countryId ?? 0,
    });

  const isResults = isSuccess && data.result.length !== 0;

  return (
    <>
      {isResults && (
        <>
          <SeasonalProductsSection
            data={data?.result}
            isLoading={isLoading}
            isFetching={isFetching}
            {...restProps}
          />
          <Space size={75} mobile={70} />
        </>
      )}
    </>
  );
};

export const SeasonalProductsSectionAdapter = memo(
  _SeasonalProductsSectionAdapter
);
